import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/clinicians/leaderboard")({
    beforeLoad: () => {
        throw redirect({ to: "/customers/clinicians", replace: true });
    },
});
